// Temporary frontend-only flag. Replace with `/me`-derived config when ready.
export const LOCATION_REQUIRED = true;
